import { Colors } from "@zapier/design-system";
/** IMPORTANT! If you make changes to these vars, check the CSS files of each node type and adjust accordingly */

export const MAX_TITLE_LENGTH = 255;

export const GAP_BETWEEN_NODES = 400;

export const PATH_NODE_HEIGHT = 120;

export const PATH_NODE_WIDTH = 120;

export const DEFAULT_NODE_HEIGHT = 60;

export const DEFAULT_NODE_WIDTH = 280;

export const ZAP_STEP_NODE_HEIGHT = 45; // Must match height in ZapStepNode.module.css

export const HANDLE_DIST_FROM_TOP = 30;

export const ZAP_STEP_NODE_HANDLE_DIST_FROM_TOP = ZAP_STEP_NODE_HEIGHT / 2;

/** Width of the product navigation (left sidebar) in pixels */
export const PRODUCT_NAV_WIDTH = 44;

export const DEFAULT_SIDEBAR_WIDTH = 440;

/** Radius of the top left corner of the focus mode container in pixels when the sidebar is open */
export const FOCUS_MODE_CONTAINER_RADIUS = 10;

/** When you click a node from the diagramming toolbar, this is the node type that's created */
export const TEMP = "temp";

export const PERSISTED_NODES = [
  "default",
  "zap",
  "group",
  "path",
  "text",
] as const;

export const EPHEMERAL_NODE_TYPES = [
  "zapStep",
  "suggested",
  TEMP,
  "annotation",
] as const;

export const NODE_TYPES = [
  ...PERSISTED_NODES,
  ...EPHEMERAL_NODE_TYPES,
] as const;

export const NODE_TYPES_TO_EXCLUDE_FROM_TOUR = [
  ...EPHEMERAL_NODE_TYPES,
  ...PERSISTED_NODES.filter((type) => type === "text" || type === "group"),
] as const;

export const DEFAULT_NODE_COLOR = Colors.GrayWarm4;
export const DEFAULT_ZAP_NODE_COLOR = Colors.BrandPeach;
export const DEFAULT_TABLE_NODE_COLOR = Colors.BrandNight;
export const DEFAULT_INTERFACE_NODE_COLOR = Colors.BrandLavender;
export const DEFAULT_CHATBOT_NODE_COLOR = Colors.BrandSky;
export const DEFAULT_AGENT_NODE_COLOR = Colors.GrayWarm9;

// Default background colors
export const DEFAULT_NODE_BACKGROUND_COLOR = Colors.BackgroundWeaker;
export const DEFAULT_ZAP_NODE_BACKGROUND_COLOR = "#FFF8F1";
export const DEFAULT_TABLE_NODE_BACKGROUND_COLOR = "#F0EEF5";
export const DEFAULT_INTERFACE_NODE_BACKGROUND_COLOR = "#FCFBFF";
export const DEFAULT_CHATBOT_NODE_BACKGROUND_COLOR = "#FBFDFC";
export const DEFAULT_AGENT_NODE_BACKGROUND_COLOR = Colors.GrayWarm1;
